<template>
  <v-div class="LinkSet">
    <fieldset>
      <legend
        :class="[
          { 'font-weight-bold': titleBold },
          'v-div',
          'title',
          `${titleColor}--text`,
        ]"
      >
        {{ title }}
      </legend>
      <LinkBucket
        v-for="bucket in buckets"
        :key="bucket.key"
        :bucket="bucket"
        :selected="selected"
        @selectionChanged="$emit('selectionChanged', $event)"
      />
      <v-div border-bottom-inverted-thick mt-3 ml-1 mr-1 />
    </fieldset>
  </v-div>
</template>

<script>
import LinkBucket from "~/components/matches/components/LinkBucket.vue";

export default {
  name: "LinkSet",
  components: {
    LinkBucket,
  },
  props: {
    title: { type: String, required: true },
    titleColor: { type: String, required: true },
    titleBold: { type: Boolean, required: true },
    buckets: { type: Array, required: true },
    selected: { type: Array, required: true },
  },
};
</script>

<style>
.LinkSet > fieldset {
  border: none;
  padding: 0;
  margin: 0;
}

.LinkSet > fieldset legend {
  border: none;
  padding: 0;
  margin: 0;
  width: fit-content !important;
}
</style>
